import { CalendarDate } from '@internationalized/date';
import {
  CreatePurchaseOrderInput,
  PurchaseOrderStatus,
  CreatePurchaseOrderLineItemInput,
  FreightTerm,
  PaymentTerm,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseOrderCreateAtom = createMutationAtomFactory(
  'trade.purchaseOrderCreate',
  (params: {
    documentNumber?: string;
    status: PurchaseOrderStatus;
    startDate?: CalendarDate | null;
    endDate?: CalendarDate | null;
    accountId: string;
    accountContactId?: string | null;
    accountRepresentativeId?: string | null;
    counterpartyReferenceNumber?: string | null;
    accountAddressId: string;
    facilityId: string;
    paymentCurrency: string;
    freightTerm: FreightTerm;
    paymentTerm: PaymentTerm;
    notes?: string | null;
    completionNotes?: string | null;
    lineItems?: CreatePurchaseOrderLineItemInput[];
  }) => {
    const input: CreatePurchaseOrderInput = {
      status: params.status,
      accountId: params.accountId,
      accountAddressId: params.accountAddressId,
      facilityId: params.facilityId,
      paymentCurrency: params.paymentCurrency,
      freightTerm: params.freightTerm,
      paymentTerm: params.paymentTerm,
    };

    if (params.documentNumber) input.documentNumber = params.documentNumber;
    if (params.startDate) input.startDate = params.startDate.toString();
    if (params.endDate) input.endDate = params.endDate.toString();
    if (params.accountContactId)
      input.accountContactId = params.accountContactId;
    if (params.accountRepresentativeId)
      input.accountRepresentativeId = params.accountRepresentativeId;
    if (params.counterpartyReferenceNumber)
      input.counterpartyReferenceNumber = params.counterpartyReferenceNumber;
    if (params.notes) input.notes = params.notes;
    if (params.completionNotes) input.completionNotes = params.completionNotes;
    if (params.lineItems) input.lineItems = params.lineItems;

    return {
      tradePurchaseOrderCreate: {
        __args: {
          input,
        },
        id: true,
        documentNumber: true,
        status: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
